/**
 * Created by andrey on 05.08.26
 */

const SeasonPassMerge3Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (mission.getType() === Mission.TYPE_SEASON_PASS) {
                SeasonPassMerge3Adapter.bindCompletionAnimation(mission);
                SeasonPassMerge3Adapter.bindRewardsFlight(mission);
            }
        });

        const running = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        if (running) {
            SeasonPassMerge3Adapter.bindCompletionAnimation(running);
            SeasonPassMerge3Adapter.bindRewardsFlight(running);
        }

        cleverapps.eventBus.on("mapEvent", (type, options) => {
            if (type === Map2d.EXCHANGE) {
                SeasonPassMerge3Adapter.fly("complete_orders", options.affected, SeasonPassMerge3Adapter.createStar);
                SeasonPassMerge3Adapter.applyProgress("complete_orders", 1);
            }
        });

        cleverapps.eventBus.on("merge_units", (amount, cell) => {
            SeasonPassMerge3Adapter.fly("merge_items", cell, SeasonPassMerge3Adapter.createStar);
            SeasonPassMerge3Adapter.applyProgress("merge_items", amount || 1);
        });

        cleverapps.eventBus.on("spendEnergy", (amount) => {
            if (!amount || amount <= 0) {
                return;
            }
            SeasonPassMerge3Adapter.applyProgress("spend_energy", amount);
        });

        cleverapps.eventBus.on("useEnergy", (unit) => {
            SeasonPassMerge3Adapter.fly("spend_energy", unit, () => new Reward("energy", 1).getSmallIcon());
        });

        cleverapps.eventBus.on("spend_hard", (amount) => {
            if (!amount || amount <= 0) {
                return;
            }
            SeasonPassMerge3Adapter.applyProgress("spend_hard", amount);
        });
    },

    bindCompletionAnimation: function (mission) {
        const questPack = mission.logic && mission.logic.questPack;
        if (!questPack || questPack.completionAnimationBound) {
            return;
        }
        questPack.completionAnimationBound = true;

        questPack.on("questCompleted", (quest) => {
            SeasonPassQuestCompleteAnimation.show(quest);
        });
    },

    bindRewardsFlight: function (mission) {
        const logic = mission.logic;
        if (!logic || logic.rewardsFlightBound) {
            return;
        }
        logic.rewardsFlightBound = true;

        let hiddenWindow;

        logic.on("stageClaimed", (stage, vip) => {
            const stageConfig = logic.getStagesConfig()[stage];
            const reward = stageConfig && (vip ? stageConfig.vip : stageConfig.free);
            if (!reward || !reward.units) {
                return;
            }

            const currentWindow = cleverapps.focusManager.currentWindow();
            hiddenWindow = currentWindow && ComponentMap.get(currentWindow, WindowComponent);
            if (hiddenWindow) {
                hiddenWindow.hideWindow();
            }
        });

        logic.on("stageRewardsCollected", () => {
            if (hiddenWindow) {
                hiddenWindow.displayWindow();
                hiddenWindow = undefined;
            }
        });
    },

    findQuestPack: function () {
        if (typeof Mission === "undefined" || Mission.TYPE_SEASON_PASS === undefined) {
            return undefined;
        }

        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        return mission && mission.isRunning() && mission.logic && mission.logic.questPack;
    },

    applyProgress: function (questType, amount) {
        const questPack = SeasonPassMerge3Adapter.findQuestPack();
        if (questPack) {
            questPack.applyProgress(questType, amount);
        }
    },

    createStar: function () {
        const star = new cleverapps.Spine(bundles.merge.jsons.seasonpass_point);
        star.setAnimation(0, "idle", true);
        return star;
    },

    fly: function (questType, cell, createIcon) {
        const questPack = SeasonPassMerge3Adapter.findQuestPack();
        const target = cleverapps.aims.getTarget(`mission${Mission.TYPE_SEASON_PASS}`, { noDefault: true });
        const flying = SeasonPassMerge3Adapter.flying[questType];
        if (!cell || !questPack || !questPack.hasQuest(questType) || !target || (flying && flying.isRunning())) {
            return;
        }

        const mapView = Map2d.currentMap.getMapView();
        const position = mapView.animations.convertToWorldSpace(mapView.getUnitCenterPos(cell.x, cell.y));
        const scene = cleverapps.Scenes.GetRunningScene();
        const icon = SeasonPassMerge3Adapter.flying[questType] = createIcon();
        icon.setPosition(scene.convertToNodeSpace(position));
        scene.addChild(icon);

        icon.runAction(StandartAnimations.animateCollect(icon, target, {
            adjustToTarget: true,
            collectEffect: true,
            removeOnFinish: true
        }));
    },

    flying: {}
};

cleverapps.whenAllInitialized(() => SeasonPassMerge3Adapter.SubscribeToEvents());